module.exports = {
	message: {
		hello_world: '世界 你好'
	},
	down: {
		grid_bot: '網格量化工具',
		overcome_emotional: '克服投資情緒',
		fortune_market: '輕鬆穿越牛熊',
		contact_email: '聯繫客服郵箱',
		copy_success: '複製成功',
		copy_failed: '複製失敗',
		press_copy: '請長按邀請碼進行複製',
		overseas: '需要海外',
		register_guide: '註冊美區ID指引',
		recommend: '推薦',
		enterprise: '企業簽名版',
		anytime: '隨時隨地',
		trade: '交易',
		stay_tuned: '敬請期待',
	},
	sign: {
		register_id: '註冊帳號',
		mobile_regist: '手機註冊',
		email_regist: '郵箱註冊',
		input_phone: '請輸入手機號',
		input_email: '請輸入郵箱地址',
		set_password: '請設置密碼',
		password_rule: '8-16位數字、字母組合',
		password_warn: '要同時含有數字和字母，長度要在8-16位之間',
		invite_code: '推薦人邀請碼',
		agree: '我已閱讀並同意',
		user_agr: '《用戶協議》',
		privacy_agr: '《隱私協議》',
		and: '和',
		regist: '註冊',
		agree_warn: '請先閱讀並同意協議',
		already_regist: '已註冊？點擊下載',
		phone_warn: '手機號碼輸入有誤，請重新填寫',
		email_warn: '郵箱格式有誤，請重新填寫',
		input_code: '輸入驗證碼',
		code_sended: '驗證碼已發送至：',
		re_get: '40s後重新獲取',
		regist_success: '恭喜您註冊成功',
		down_app: '下載APP',
		user_exists: '該用戶已存在',
		resend: '重新獲取',
		wrong_code: '驗證碼有誤',
		choose_area: '選擇國家或地區',
		search: '搜索',
		mobile_xp: '手機號碼',
		email_xp: '郵箱地址',
		code_xp: '驗證碼',
		get_code_xp: '獲取驗證碼',
		get_code2_xp: '後重新獲取',
		set_pwd: '設置密碼',
		regist_text: '註冊即代表閱讀並同意',
		trade: '隨時隨地 移動交易',
		down: '下載',
		currently_regist: '正在註冊',
		agreement: '平臺服務條款',
		no_cn: '不支持中國大陸用戶註冊'
	},
	common: {
		jgz: '金果子',
		jgz_down: '金果子下載',
		invite_regist: '邀請註冊',
		open_in_browser: '請在瀏覽器中打開',
		jgz_team: 'JGZ團隊',
		refresh: '點擊重繪',
		xp_team: 'XP團隊',
		load: '加載中~',
		xp_network: '網路請求超時，請稍後重試',
	},
	invite: {
		scan_down: '掃碼下載金果子APP',
		invite_code: '邀請碼',
		invite: '立即邀請',
		not_apple: '本活動與蘋果公司無關',
		invite_friend: '邀請好友',
		get_bot: '一起量化',
		invite_xp: '邀請好友 一起量化',
		scan_down_xp: '掃碼下載',
		invite_code_xp: '邀請鏈接',
		invite_text_xp: '也可以通過以下方式邀請',
		invite_code2_xp: '複製邀請碼',
		invite_url_xp: '複製鏈接',
		invite_hb_xp: '生成海報',
		invite_back: '返回',
		invite_save: '保存圖片',
	},
	activity: {
		jgz_activity: 'JGZ 活動',
		failed: '哦呦！ 獲取失敗。',
		course: '教程',
		service: '線上客服',
		consult: '諮詢',
		service_text: '由於幣安的相關政策規定，在2024年06月01日前未完成KYC的帳戶將會對其進行封禁，請各位用戶知悉。如有疑問，請在APP聯繫',
		service_h2: '尊敬的用戶',
		service_title: '關於未完成KYC帳號封禁公告',
	},
	alarm: {
		how: '如何添加預警？',
		way: '登錄狀態下，打開任意交易對K線頁面，點擊預警按鈕，即可添加價格預警。'
	},
	activityXP: {
		title: '新用戶註冊豪禮',
		h1: '加密交易所',
		h2: '註冊豪禮等你拿',
		activityTime: '活動時間：2025/06/06 ~ 2025/08/31',
		activityRule: '活動規則',
		activityRuleDetail: '活動期間，註冊並完成實名認證且累計交易金額達到100美元(含)以上的用戶，自動參與瓜分30萬美元。',
		exchangeRule: '兌獎規則',
		exchangeRuleDetail: '用戶領獎金額將根據活動期間個人交易額與本交易所總交易額的占比份額進行分配。',
		exchangeType: '兌獎方式',
		exchangeTypeDetail: '獎金將於 2025/09/01 ~ 2025/09/07 期間自動發放至用戶帳戶。',
	}
}